import { getCssVarDefine, getCssVarObject } from '../utils/makeCSSVariable';
import { COLORS_LIGHT, COLORS_DARK } from './raw-value';

/**
 * =============================================
 *             Design Token - Color
 * =============================================
 * 
 * 因为要和 @ali/we-colors 严格保持一致，因此不手动生成，而是基于 @ali/we-colors 自动生成
 */

var COLOR_CSS_VARS_LIGHT = getCssVarDefine(COLORS_LIGHT, 'color');
var COLOR_CSS_VARS_DARK = getCssVarDefine(COLORS_DARK, 'color');

/**
 * 颜色对象
 * 
 * 调用后获取到的为 CSS 变量，因此仅限在支持 CSS 变量的环境下使用
 * 
 * 用法：COLORS.BG_DEFAULT -> 'var(--we_bg_default_color, #fff)'
 * 
 * 如需自动 Dark Mode，使用前请确保页面中已经引入了 CSS 变量声明集 COLOR_CSS_VARS
 * 
 * React 环境下，可以使用 Design Token Provider 来自动完成引入
 * 
 * 如在未引用 CSS 变量声明集情况下单独使用本对象，则只会提供 Light Mode 的颜色
 */
export var COLORS = getCssVarObject(COLORS_LIGHT, 'color');
export var COLOR_CSS_VARS = {
  light: COLOR_CSS_VARS_LIGHT,
  dark: COLOR_CSS_VARS_DARK
};